import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { RateTemplateLine } from "../_types/rate-template-line";

@Injectable({
  providedIn: 'root',
})
export class RatesTemplatesLinesService extends Service<RateTemplateLine> {
  public override type = 'rateTemplateLines';
  public override url = 'attendance/rateTemplateLines';

}